module.exports = __webpack_public_path__ + "img/B-6.74b9be51.png";